import React from "react";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect } from "react-redux";
import { RouteProps, RouterProps } from "react-router";
import { Grid, Typography } from "material-ui";
import { SetShowBackNavigation } from "ducks/common";

interface IAccessibilityPageStateProps { }
interface IAccessibilityPageDispatchProps {
    ShowBackNavigation: () => void;
    HideBackButton: () => void;
}

type IAccessibilityPageProps = IAccessibilityPageDispatchProps &
    RouterProps &
    RouteProps;

class AccessibilityPage extends React.Component<
    IAccessibilityPageProps,
    IAccessibilityPageStateProps
> {
    componentDidMount() {
        this.props.ShowBackNavigation();
    }

    componentWillUnmount() {
        this.props.HideBackButton();
    }

    public render() {
        return (
            <div className="AccessibilityPage">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid
                            className="text-container"
                            item
                            xs={12}
                            sm={10}
                            md={10}
                            lg={10}
                        >
                            <h2>
                                Hypon Mobiilipankin saavutettavuusseloste
                            </h2>

                            <Typography>
                                Tämä saavutettavuusseloste koskee Suomen
                                Hypoteekkiyhdistyksen (jäljempänä ”Hypo”)
                                palvelua Hypon Mobiilipankki. Seloste on
                                päivitetty 27.6.2025.
                            </Typography>

                            <h3>Kuvaus palvelusta</h3>

                            <Typography>
                                Hypon Mobiilipankki on digitaalinen asiointipalvelu,
                                jonka avulla asiakkaat voivat tarkastella lainojaan,
                                talletuksiaan ja asuntovarallisuuttaan sekä lähettää
                                viestejä Hypolle turvallisesti. Palvelu on
                                käytettävissä sekä selaimella että mobiilisovelluksena.
                            </Typography>

                            <h3>Saavutettavuuden tila</h3>

                            <Typography>
                                Ulkopuolinen asiantuntijaorganisaatio Pixels
                                Helsinki Oy on tarkistanut palvelun saavutettavuuden
                                WCAG 2.1 AA-tason vaatimuksia vastaan toukokuussa
                                2021 ja siinä on todettu, että Hypon Mobiilipankki
                                vastaa WCAG 2.1 AA-tason vaatimuksia.
                            </Typography>

                            <h3>B2-tason kielivaatimusta koskeva lisävaatimus</h3>

                            <Typography>
                                Hypon Mobiilipankissa palvelujen tarjoamista
                                koskevat tiedot täyttävät Euroopan neuvoston
                                kieliä koskevan yhteisen eurooppalaisen viitekehyksen
                                B2-tason. Palvelu on sisällöltään selkeä ja sen
                                kieliasu noudattaa yleiskielisiä ilmaisutapoja.
                                <br />
                                <br />
                                B2-tason täyttymistä koskeva saavutettavuusarviointi
                                on toteutettu Hypon toimesta sisäisesti.
                            </Typography>

                            <h3>Palautteet ja yhteystiedot</h3>

                            <Typography>
                                Jos huomaat sivustolla saavutettavuusongelmia, ota
                                yhteyttä meihin, jotta voimme sopia tietojen
                                toimittamisesta Sinulle sopivalla tavalla. Voit
                                myös jättää palautetta ja saavutettavuuteen
                                liittyviä kysymyksiä osoitteessa&nbsp;
                                <a href="mailto:saavutettavuuspalaute@hypo.fi">
                                    saavutettavuuspalaute@hypo.fi
                                </a>. Vastaamme palautteeseen 14 päivän kuluessa,
                                mikäli olet jättänyt yhteystietosi.
                            </Typography>

                            <h3>Valvontaviranomainen</h3>

                            <Typography>
                                Mikäli et ole tyytyväinen saavutettavuuspalautteeseen
                                saamaasi vastaukseen, voit olla yhteydessä
                                valvontaviranomaiseen eli Liikenne- ja viestintävirasto
                                Traficomiin. Saavutettavuusvaatimukset.fi-sivustolla
                                annetaan tarkemmat ohjeet siitä, miten ilmoituksen voi
                                tehdä ja miten asia käsitellään.
                            </Typography>

                            <h3>Valvontaviranomaisen yhteystiedot</h3>

                            <Typography>
                                Liikenne- ja viestintävirasto Traficom
                                Digitaalisen esteettömyyden ja saavutettavuuden
                                valvontayksikkö<br />
                                <a href="mailto:saavutettavuus@traficom.fi">
                                    saavutettavuus@traficom.fi
                                </a><br />
                                puhelinnumero: vaihde 029 534 5000<br />
                                <a href="https://www.saavutettavuusvaatimukset.fi"
                                    target="_blank" rel="noopener noreferrer">
                                    www.saavutettavuusvaatimukset.fi
                                </a>
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (_state: ReduxState): IAccessibilityPageStateProps => {
    return {};
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): IAccessibilityPageDispatchProps => {
    return {
        ShowBackNavigation: () => {
            return dispatch(SetShowBackNavigation(true));
        },
        HideBackButton: () => {
            return dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessibilityPage);



// WEBPACK FOOTER //
// ./src/views/about/AccessibilityPage.tsx